import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import RewardsBadgeWithColor from 'JS/components/RewardsBadgeWithColor.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import TransitionFade from 'JS/components/transitions/TransitionFade.vue';
import { computed, ref, watch } from 'vue';
import { usePreventBodyScroll } from 'JS/composables/prevent-body-scroll';
import { WorkOrderTotalResource, WorkOrderTotalType } from '../../types/session';


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkOrderWrapper',
  props: {
    floating: { type: Boolean },
    total: null,
    rewardsPoints: null
  },
  setup(__props: any) {

const props = __props as {
	floating?: boolean;
	total: WorkOrderTotalResource;
	rewardsPoints?: string | null;
}



const open = ref(false);
const toggle = () => open.value = !open.value;
const ariaExpanded = computed(() => open.value.toString() as 'true' | 'false');

// ensure closed and that body scrolling is re-enabled
watch(() => props.floating, floating => {
	if (!floating && open.value) {
		open.value = false;
	}
});

usePreventBodyScroll(open);

const total = computed(() => {
	switch (props.total.type) {
		case WorkOrderTotalType.Normal:
			return {
				label: props.total.showAsEstimate
					? 'Estimated Subtotal'
					: 'Total',
				value: props.total.amount,
			};
		case WorkOrderTotalType.TBD:
		default:
			return {
				label: 'Total',
				value: 'TBD',
			};
	}
});

return { __sfc: true,props, open, toggle, ariaExpanded, total, Icon, RewardsBadgeWithColor, TransitionExpand, TransitionFade }
}

})